import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Input,
  Output,
  Signal,
  HostBinding,
} from '@angular/core';
import { AssistantChatData } from '../../model';
import { UiIconModel } from '@local/ui-infra';
import { toSignal } from '@angular/core/rxjs-interop';
import { Assistants } from '@local/client-contracts';
import { AssistantsService } from '@shared/services/assistants.service';
import { isExtension } from '@local/common-web';

@Component({
  selector: 'chat-empty-state',
  templateUrl: './chat-empty-state.component.html',
  styleUrls: ['./chat-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatEmptyStateComponent {
  readonly EMPTY_STATE_ICON: UiIconModel = {
    type: 'img',
    value: {
      lightUrl: './assets/chat/empty-state-light.svg',
      darkUrl: './assets/chat/empty-state-dark.svg',
    },
  };
  private assistantService: AssistantsService = inject(AssistantsService);
  private isExtension = isExtension();

  assistantData = input<AssistantChatData>();
  showResumeLastThread = input<boolean>();

  llms: Signal<Assistants.AssistantLlmsResponseItem[]>;
  modelName = computed(() => {
    return this.llms()?.find((llm) => this.assistantData()?.model === llm.id)?.name;
  });

  @Output() handleStartConversation = new EventEmitter<string>();
  @Output() onResumeLastThread = new EventEmitter();

  @HostBinding('attr.isExtensionMode')
  get isExtensionMode() {
    return this.isExtension;
  }

  resumeLastThread() {
    this.onResumeLastThread.emit();
  }

  openNewChatWithConversationStarter(starter: string) {
    this.handleStartConversation.emit(starter);
  }

  constructor() {
    this.llms = toSignal(this.assistantService.llms$);
  }
}
